import { useLanguage } from 'features/hooks/useLanguage';
import { CircleAlert } from 'lucide-react';
import { LanguageType } from 'types/enums';
import { useAutoClearedFields } from '../AutoClearedFieldsContext';
import { useState } from 'react';
import { Diffs } from './Diffs';

export const AutoClearedFieldsInfo = () => {
	const diffs = useAutoClearedFields();

	const language = useLanguage();
	const translation = DICTIONARY[language];

	const [expanded, setExpanded] = useState(false);

	if (!diffs.size) {
		return null;
	}

	const regionId = 'auto-cleared-fields-details';
	const titleId = 'auto-cleared-fields-title';

	return (
		<div
			className="mb-16 overflow-hidden rounded-md bg-warning-200/25"
			role="region"
			aria-labelledby={titleId}
		>
			<div className="flex items-center gap-2">
				<div className="flex items-center self-stretch px-4 bg-warning-200">
					<CircleAlert aria-hidden="true" className="size-6 text-warning-800" />
				</div>

				<div className="flex items-center flex-1 gap-3 px-1 py-4">
					<p className="flex-1 text-base font-semibold text-warning-800" id={titleId}>
						{translation.title}
					</p>

					<button
						type="button"
						onClick={() => setExpanded(prev => !prev)}
						aria-expanded={expanded}
						aria-controls={regionId}
						className="pr-2 text-sm font-semibold text-warning-700 hover:underline"
					>
						{expanded ? translation.hideDetails : translation.showDetails}
					</button>
				</div>
			</div>

			{expanded && (
				<div id={regionId} className="px-6 py-3 border-t border-warning-200">
					<p className="mb-2 text-sm text-warning-700">{translation.subtitle}</p>
					<Diffs diffs={[...diffs.values()]} showDependency />
				</div>
			)}
		</div>
	);
};

const DICTIONARY = {
	[LanguageType.English]: {
		title: 'Some field(s) were cleared automatically',
		subtitle:
			'These values were removed because their dependency conditions are no longer met, this usually happens because dependency rules have been changed after the data has been filled. Contact the register administrator if this is unexpected',
		showDetails: 'Show details',
		hideDetails: 'Hide details',
		columnField: 'Field',
		columnPreviousValue: 'Previous value',
		columnNewValue: 'New value'
	},

	[LanguageType.Norwegian]: {
		title: 'Noen felt ble automatisk tømt',
		subtitle:
			'Disse verdiene ble fjernet fordi avhengighetsreglene ikke lenger er oppfylt, dette skjer typisk fordi avhengighetsreglene har blitt endret etter data har blitt fylt in. Kontakt registeradministrator dersom dette er uventet',
		showDetails: 'Vis detaljer',
		hideDetails: 'Skjul detaljer',
		columnField: 'Felt',
		columnPreviousValue: 'Tidligere verdi',
		columnNewValue: 'Ny verdi'
	}
};
